<div if.bind="sourceAdmin.panelOpen" class="modal-overlay" click.trigger="sourceAdmin.closePanel()">
  <div class="source-admin" click.trigger="$event.stopPropagation()">
    <div class="source-admin__header">
      <h3 class="source-admin__title">Sources</h3>
      <button type="button" class="source-admin__close" click.trigger="sourceAdmin.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="source-admin__body">
      <p class="source-admin__hint">Turning a source off stops future scrapes. Releases already saved stay visible.</p>

      <div if.bind="sourceAdmin.loading" class="source-admin__status">Loading sources&hellip;</div>
      <div if.bind="sourceAdmin.error" class="source-admin__error">${sourceAdmin.error}</div>

      <ul if.bind="!sourceAdmin.loading" class="source-admin__list">
        <li repeat.for="source of sourceAdmin.sources" class="source-admin__row">
          <span class="source-admin__name">${source.id}</span>
          <button
            type="button"
            class="source-admin__switch ${source.enabled ? 'source-admin__switch--on' : ''}"
            click.trigger="sourceAdmin.toggle(source)"
            disabled.bind="source.saving"
            role="switch"
            aria-checked.bind="source.enabled"
            aria-label="Toggle ${source.id}">
            <span class="source-admin__switch-knob"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="source-admin__footer">
      <button type="button" class="login-btn login-btn--primary" click.trigger="sourceAdmin.closePanel()">Close</button>
    </div>
  </div>
</div>
